"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundIndex = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundIndex = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundIndex, _super);
    function FundIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '众禄基金收益走势';
        _this.code = '106018';
        _this.desc = '众禄基金收益走势';
        _this.requestParams = new zl_1.FundIndexRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundIndex;
}(service_1.BaseService));
exports.FundIndex = FundIndex;
//# sourceMappingURL=fundIndex.js.map